import WalletConnect from "@walletconnect/web3-provider";
import CoinbaseWalletSDK from "@coinbase/wallet-sdk";

export const providerOptions = {
//   walletlink: {
//     package: CoinbaseWalletSDK, // Required
//     options: {
//       appName: "Web 3 Modal Demo", // Required
//       infuraId: "faf8b23ece444745b4f64a6c6f242072"// process.env.REACT_APP_INFURA_KEY // Required unless you provide a JSON RPC url; see `rpc` below
//     }
//   },
  walletconnect: {
    package: WalletConnect, // required
    options: {
      infuraId: "faf8b23ece444745b4f64a6c6f242072",// process.env.REACT_APP_INFURA_KEY // required
    }
  }
};
